export default {
  title: 'Recompensas',
  guest: {
    eyebrow: 'Recompensas',
    headline: 'Cada pedido te da <highlight>recompensas</highlight>',
    subheading_one: 'Gana {{count}} punto por cada {{amount}} gastado.',
    subheading_other: 'Gana {{count}} puntos por cada {{amount}} gastado.',
    cta: 'Regístrate y empieza a ganar',
    already_member: '¿Ya eres miembro?',
    sign_in: 'Iniciar sesión',
    redeemable_heading: 'Tus puntos = comida gratis',
    redeemable_eyebrow: '🎁 Recompensas que desbloquearás',
  },
  member: {
    balance_label: 'Tu saldo',
    balance_suffix: 'puntos · valor <highlight>{{amount}}</highlight>',
    next_reward: 'Próxima recompensa a <highlight>{{points}} pts</highlight>',
    redeem_hint: '✓ Puedes canjear hasta {{points}} pts ({{amount}}) en tu próximo pedido',
    expiration_zero: '⏳ {{points}} pts vencen hoy',
    expiration_one: '⏳ {{points}} pts vencen en 1 día',
    expiration_other: '⏳ {{points}} pts vencen en {{count}} días',
    pts_lifetime: 'Vigencia de pts',
    saved_lifetime: 'Ahorro total',
    cta: 'Pedir ahora',
    redeemable_heading: 'Qué puedes canjear',
    redeemable_eyebrow: 'Tienes {{points}} pts ({{amount}})',
    redeemable_description:
      'Hasta {{maxPoints}} pts ({{maxAmount}}) por pedido. Los artículos de menos de {{maxAmount}} son completamente gratis.',
  },
  items: {
    free: 'GRATIS',
    save: 'Ahorra {{amount}}',
  },
  history: {
    eyebrow: 'Historial',
    title: 'Actividad reciente',
    load_more: 'Cargar más',
    sources: {
      welcome_bonus: 'Bono de bienvenida',
      google_review_reward: 'Recompensa por reseña en Google',
      reward_loyalty_program_conversion: 'Conversión de programa de fidelidad',
      cashback: 'Cashback ganado',
      refund: 'Pedido reembolsado',
      cashback_usage: 'Puntos canjeados',
      cashback_usage_refund: 'Canje reembolsado',
      expired_points_void: 'Puntos caducados',
      mobile_app_signup_bonus: 'Bono por registro en app móvil',
    },
    detail_with_order: 'Pedido #{{number}} · {{amount}}',
  },
  how_it_works: {
    eyebrow_guest: 'Simple y automático',
    eyebrow_member: 'Recordatorio rápido',
    title: 'Cómo funciona',
    steps: {
      sign_up: {
        emoji: '📲',
        title: 'Regístrate gratis',
        desc: 'Crea una cuenta en 30 segundos.',
      },
      order: {
        emoji: '🍔',
        title: 'Pide y gana',
        desc_one: '1 pt por {{amount}} — seguimiento automático.',
        desc_other: '{{count}} pts por {{amount}} — seguimiento automático.',
      },
      build: {
        emoji: '⭐',
        title: 'Acumula puntos',
        desc: 'Canjea desde {{minPoints}} pts. Válidos {{lifetime}} días.',
      },
      save: {
        emoji: '🎁',
        title: 'Ahorra al pagar',
        desc: 'Hasta {{maxAmount}} de descuento — aplicado al instante.',
      },
      repeat: {
        emoji: '🔄',
        title: 'Repite y ahorra',
        desc: 'Cada pedido aumenta tu saldo.',
      },
    },
  },
  faq: {
    eyebrow: '¿Preguntas?',
    title: 'Preguntas frecuentes',
    items: {
      earn: {
        q: '¿Cómo gano puntos?',
        a_one:
          'Ganas 1 punto por cada {{amount}} que gastas. Los puntos se añaden automáticamente a tu cuenta tras cada pedido — sin escanear ni códigos.',
        a_other:
          'Ganas {{count}} puntos por cada {{amount}} que gastas. Los puntos se añaden automáticamente a tu cuenta tras cada pedido — sin escanear ni códigos.',
      },
      redeem: {
        q: '¿Cuándo puedo empezar a canjear?',
        a: 'Puedes canjear cuando alcances {{minPoints}} puntos. Úsalos al pagar para reducir el total.',
      },
      max: {
        q: '¿Cuánto puedo ahorrar por pedido?',
        a: 'Puedes canjear hasta {{maxPoints}} puntos ({{maxAmount}}) por pedido. Es el descuento máximo por compra.',
      },
      validity: {
        q: '¿Cuánto tiempo son válidos los puntos?',
        a: 'Los puntos son válidos durante {{lifetime}} días desde que se ganan. ¡Úsalos antes de que caduquen!',
      },
    },
  },
};
